import React from "react";

import { Minus, Plus } from "lucide-react";

import { useBundleBuilder } from "../BundleBuilderContext";

export const BundleQuantitySelector = ({
  variantId,
}: {
  variantId: string;
}) => {
  const {
    removeItemFromBundle,
    getItemQuantity,
    updateItemQuantity,
    canAddVariantToBundle,
  } = useBundleBuilder();
  const quantity = getItemQuantity(variantId);

  const isAbleToIncrement = canAddVariantToBundle(variantId);

  const incrementQuantity = () => {
    if (isAbleToIncrement) {
      updateItemQuantity(variantId, quantity + 1);
    }
  };

  const decrementQuantity = () => {
    if (quantity <= 1) {
      removeItemFromBundle(variantId);
    } else {
      updateItemQuantity(variantId, quantity - 1);
    }
  };
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        borderRadius: "6px",
        overflow: "hidden",
      }}
    >
      <button
        style={{
          flex: 1,
          padding: "7px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #E2E8F0",
          backgroundColor: "#F8FAFC",
          cursor: "pointer",
        }}
        onClick={decrementQuantity}
      >
        <Minus size={14} />
      </button>
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "7px",
          border: "1px solid #E2E8F0",
          borderLeft: "none",
          borderRight: "none",
          backgroundColor: "white",
        }}
      >
        {quantity}
      </div>
      <button
        disabled={!isAbleToIncrement}
        style={{
          flex: 1,
          padding: "7px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #E2E8F0",
          backgroundColor: "#F8FAFC",
          cursor: isAbleToIncrement ? "pointer" : "auto",
          opacity: isAbleToIncrement ? 1 : 0.6,
        }}
        onClick={incrementQuantity}
      >
        <Plus size={14} />
      </button>
    </div>
  );
};
